import { WEBSOCKET_URL } from "../config";

let socket: WebSocket | null = null;
let connectionState: 'disconnected' | 'connecting' | 'connected' | 'error' = 'disconnected';

export const connectWebSocket = (
  challengeId: string,
  page: number,
  limit: number,
  handlers: {
    onRowUpdate?: (index: number, data: any) => void;
    onUserEnter?: (index: number, data: any) => void;
    onUserLeave?: (userId: string) => void;
    onPriceUpdate?: (symbol: string, price: number) => void;
    onConnectionChange?: (state: 'disconnected' | 'connecting' | 'connected' | 'error') => void;
  }
) => {
  // Close existing connection if any
  if (socket) {
    socket.close();
    socket = null;
  }

  connectionState = 'connecting';
  handlers.onConnectionChange?.(connectionState);

  try {
    socket = new WebSocket(
      `${WEBSOCKET_URL}/ws/admin/leaderboard/${challengeId}`
    );

    socket.onopen = () => {
      console.log('WebSocket connection opened');
      connectionState = 'connected';
      handlers.onConnectionChange?.(connectionState);
      
      socket?.send(
        JSON.stringify({
          type: "subscribe",
          page,
          limit,
        })
      );
    };

    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        console.log('WebSocket message received:', msg.type, msg);
        
        switch (msg.type) {
          case "leaderboard_row":
            if (typeof msg.index === 'number' && msg.data) {
              handlers.onRowUpdate?.(msg.index, msg.data);
            } else {
              console.warn('Invalid leaderboard_row message:', msg);
            }
            break;
          case "user_entered_page":
            if (typeof msg.index === 'number' && msg.data) {
              handlers.onUserEnter?.(msg.index, msg.data);
            } else {
              console.warn('Invalid user_entered_page message:', msg);
            }
            break;
          case "user_left_page":
            if (msg.user_id) {
              handlers.onUserLeave?.(msg.user_id);
            } else {
              console.warn('Invalid user_left_page message:', msg);
            }
            break;
          case "price_update":
            if (msg.symbol && typeof msg.price === 'number') {
              handlers.onPriceUpdate?.(msg.symbol, msg.price);
            } else {
              console.warn('Invalid price_update message:', msg);
            }
            break;
          default:
            console.log('Unknown WebSocket message type:', msg.type);
        }
      } catch (error) {
        console.error('Error parsing WebSocket message:', error, event.data);
      }
    };

    socket.onerror = (err) => {
      console.error("WebSocket error:", err);
      connectionState = 'error';
      handlers.onConnectionChange?.(connectionState);
    };

    socket.onclose = (event) => {
      console.warn("WebSocket closed:", event.code, event.reason);
      connectionState = 'disconnected';
      handlers.onConnectionChange?.(connectionState);
      socket = null;
    };

  } catch (error) {
    console.error('Error creating WebSocket connection:', error);
    connectionState = 'error';
    handlers.onConnectionChange?.(connectionState);
  }
};

export const disconnectWebSocket = () => {
  if (socket) {
    console.log('Disconnecting WebSocket...');
    socket.close();
    socket = null;
  }
  connectionState = 'disconnected';
};

export const getConnectionState = () => connectionState;

export const isConnected = () => connectionState === 'connected';
